import { FC, useCallback, useEffect, useState } from 'react';
import { IconButton, Modal, Stack, TextField } from '@fluentui/react';
import { DeleteRegular, AddRegular } from '@fluentui/react-icons';
import styles from '../styles.module.css';
import { ConsultantBio } from '../../../api';
import Button from '../../../components/Button';

type TEditConsultantBioModal = FC<{
  isOpen: boolean;
  consultantBio?: ConsultantBio;
  onSubmit: (consultantBio: ConsultantBio) => void;
  onCancel: () => void;
}>;

const blankConsultantBio: ConsultantBio = {
  FirstName: '',
  LastName: '',
  Description: '',
};

const EditConsultantBioModal: TEditConsultantBioModal = ({
  isOpen,
  consultantBio: _consultantBio,
  onSubmit,
  onCancel,
}) => {
  const [consultantBio, setConsultantBio] = useState<ConsultantBio>(_consultantBio || { ...blankConsultantBio });
  const consultantValid = consultantBio.FirstName != '' && consultantBio.LastName != '';

  const updateConsultantBio = useCallback(
    (key: keyof ConsultantBio, value: string) => {
      if (consultantBio[key] == value) return;

      setConsultantBio({ ...consultantBio, [key]: value });
    },
    [consultantBio],
  );

  useEffect(() => {
    setConsultantBio(_consultantBio || { ...blankConsultantBio });
  }, [_consultantBio, isOpen]);

  return (
    <Modal isOpen={isOpen} onDismiss={onCancel} isBlocking={true}>
      <div style={{ padding: '20px', position: 'relative' }}>
        <IconButton
          iconProps={{ iconName: 'Cancel' }}
          onClick={onCancel}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
          }}
        />
        <h2>{_consultantBio ? 'Edit' : 'Add'} a Consultant</h2>
        <Stack horizontal>
          <TextField
            className={styles.text}
            type="text"
            value={consultantBio.FirstName}
            placeholder="First name"
            onChange={(_, value) => updateConsultantBio('FirstName', value ?? '')}
            onKeyUp={e => updateConsultantBio('FirstName', e.currentTarget.value)}
          />
          <TextField
            className={styles.text}
            type="text"
            value={consultantBio.LastName}
            placeholder="Surname"
            onChange={(_, value) => updateConsultantBio('LastName', value ?? '')}
            onKeyUp={e => updateConsultantBio('LastName', e.currentTarget.value)}
          />
        </Stack>
        <TextField
          className={styles.textWide}
          type="text"
          multiline
          rows={4}
          value={consultantBio.Description}
          placeholder="Description"
          onChange={(_, value) => updateConsultantBio('Description', value ?? '')}
          onKeyUp={e => updateConsultantBio('Description', e.currentTarget.value)}
        />
        <Stack horizontal style={{ justifyContent: 'space-between', gap: '8px', margin: '8px 8px 0' }}>
          <Button label="Cancel" backgroundColor="red" color="white" icon={DeleteRegular} onClick={onCancel} />
          <Button
            label="Save"
            backgroundColor="green"
            color="white"
            icon={AddRegular}
            onClick={() => onSubmit(consultantBio)}
            disabled={!consultantValid}
          />
        </Stack>
      </div>
    </Modal>
  );
};

export default EditConsultantBioModal;
